<template>
  <div>{{data.packid.price + data.palletid.price}}</div>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {

    }
  },
  mounted () {

  }
}
</script>

<style>

</style>
